import React, {Component, PropTypes} from 'react'

export default class DynamicImageComponent extends Component {
    static propTypes = {
        documentId: PropTypes.string,
        pageNumber: PropTypes.number,
        marginBottom: PropTypes.number
    }

    constructor(props) {
        super(props)
        this.disableDragging = this.disableDragging.bind(this)
        this.state = {}
    }

    componentDidMount() {
        this.disableDragging()
    }

    componentDidUpdate() {
        this.disableDragging()
    }

    disableDragging() {
        if (!this.imageElem) {
            return
        }
        this.imageElem.setAttribute('draggable', false)
    }

    render() {
        const {documentId, pageNumber, marginBottom} = this.props

        return <img
            width={"1000"}
            src={"api/documentToImages/"+documentId+"/"+pageNumber}
            style={{marginBottom: (marginBottom*1)+"px"}}
            ref={(input) => { this.imageElem = input; }}
            data-pdf-page={true}
            data-page-number={pageNumber}
        ></img>;
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/handleSignaturePlaceholders/dynamicImageComponent.jsx